import { render, staticRenderFns } from "./OTextareaInput.vue?vue&type=template&id=bca791a4&scoped=true"
import script from "./OTextareaInput.vue?vue&type=script&lang=js"
export * from "./OTextareaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca791a4",
  null
  
)

export default component.exports